export const DEPLOY_TIME = '1478641040'

// First election whose candidate images live in a per-election, id-keyed folder
// (public/data/imgs/candidates/{date}/{polid||candidateId}.jpg). Earlier elections
// keep reading the legacy flat candidates/ dir keyed by name slug. ISO dates sort
// lexically, so `date >= NAMESPACED_IMAGES_FROM` cleanly splits new from old.
export const NAMESPACED_IMAGES_FROM = '2026-08-11'

export const DATE_WHITELIST = [
  '2026-11-03',
  '2026-08-11',
  '2024-11-05',
  '2022-11-08',
  '2020-11-03',
  '2020-08-11',
  '2020-03-03',
  '2018-11-06',
  '2016-11-08',
]

export const DATE_COMPARISON = {
  '2022-11-08': '2020-11-03',
  '2020-11-03': '2018-11-06',
  '2018-11-06': '2016-11-08',
}

// No trailing slash
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

export const TOTAL_ELECTORS = 538

export const PARTY_COLORS = {
  dem: '#4298b5',
  gop: '#eb5c40',
  ind: '#f9a909',
  lib: '#fc6d80',
  grn: '#2eba80',
  grp: '#0a3c20',
  lmn: '#177840',
  cst: '#978054',
  adp: '#12515d',
  swp: '#6b0000',
  yes: '#2eba80',
  no: '#eb5c40',
  oth: '#887777',
  wi: '#999999',
}

// TODO: make this less lazy someday (but I can't check the file system without Node, and this filter specifically proved difficult to set up)
export const THOSE_WHOMST_HAVE_PICS = [
  1036, 1445, 6588, 8639, 18446, 32324, 51516, 51526, 51545, 57725, 59911,
  61562, 61839, 62244, 62589, 63133, 63672, 63747, 64542, 64548, 64984, 67933,
  67934, 67935, 67936, 67941, 67944, 67946, 67948, 67952, 67963, 67972,
]

export const PARTY_CSS_CLASSES = {
  Dem: 'dem',
  GOP: 'gop',
  LMN: 'lmn',
  GRP: 'grp',
  Inp: 'ind',
  Grn: 'grn',
  DCG: 'grn',
  Lib: 'lib',
  ADP: 'adp',
  CST: 'cst',
  SWP: 'swp',
  Yes: 'yes',
  No: 'no',
  Oth: 'oth',
}

// Used in place of PARTY_FULL_NAMES where space is tight (e.g. the home page)
export const PARTY_SHORT_NAMES = {
  Dem: 'DFL',
}

export const PARTY_FULL_NAMES = {
  Dem: 'Democratic-Farmer-Labor',
  GOP: 'Republican',
  LMN: 'Legal Marijuana Now',
  GRP: 'Grassroots-Legalize Cannabis',
  Inp: 'Independence',
  Grn: 'Green Party',
  Lib: 'Libertarian Party',
  ADP: 'American Delta Party',
  CST: 'Constitution Party',
  SWP: 'Socialist Workers Party',
  Una: 'Unaffiliated',
  NP: 'Nonpartisan',
  Yes: ' ',
  No: ' ',
  Oth: ' ',
  WI: 'Write-in',
}
